import axios from 'axios';

import { del, get, post, put } from '../utils/apiUtils';

const API_PERMISSION_TYPE = `api/v1/mms_ai_usermanagement/rbac/permission-type`;
const API_GROUPS = `api/v1/mms_ai_usermanagement/user/group`;
const API_COMPONENT_TYPE = `api/v1/mms_ai_usermanagement/rbac/component-type`;
const API_ACCESS_CONTROL = `api/v1/mms_ai_usermanagement/rbac/access-control`;
const API_CONFIG = `/api/v1/mms_ai_configs/`;
const API_DEPENDENCY_VIEW = `api/v1/mms_ai_templates/publisher/template/dependencies/hierarchical`;
const API_GROUP = `/api/v1/mms_ai_usermanagement/user/group/get_by_name`
const API_PERMISSION_DELETE = `api/v1/mms_ai_usermanagement/rbac/access-control/delete_by_id`
/**
 * Get permission type
 * @returns {Promise<Object>} Promise resolving to waiting task
 */
    export const getAccessPermissionType = async (filter = {}, sort = {}, query = {}) => {
        try {
            const { skip = 0, limit = 10 } = query;
            const payload = {
                filter,
                sort,
                skip,
                limit,
                "invalidate_cache": false,
                "fields": []
            }
            const response = await post(`${API_PERMISSION_TYPE}/fetch`, payload);
            return response;
        } catch (error) {
            console.error('Error while fetching the access permission types:', error);
            throw error;
        }
};


/**
 * Get permission type
 * @returns {Promise<Object>} Promise resolving to waiting task
 */
    export const getAccessResourceType = async (filter = {}, sort = {}, query = {}) => {
        try {
            const { skip = 0, limit = 10 } = query;
            const payload = {
                filter,
                sort,
                skip,
                limit,
                "invalidate_cache": false,
                "fields": []
            }
            const response = await post(`${API_COMPONENT_TYPE}/fetch`, payload);
            return response;
        } catch (error) {
            console.error('Error while fetching the access permission types:', error);
            throw error;
        }
};



/**
 * Get Group data
 * @returns {Promise<Object>} Promise resolving to waiting task
 */
export const getGroupsData = async (filter = {}, sort = {}, query = {}) => {
    try {
        const {skip = 0, limit= 10} = query;
        const payload = {
            filter,
            sort,
            skip,
            limit,
            "invalidate_cache" : false,
            "fields" : []
        }
        const response = await post(`${API_GROUPS}/get_group_access_control_stats`, payload);
        return response;
    } catch (error) {
        console.error('Error while fetching the group data:', error);
        throw error;
    }
};



/**
 * Get access control count data
 * @returns {Promise<Object>} Promise resolving to waiting task
 */
export const getAccessControlCount = async (filter ={}) => {
    try {
        const response = await post(`${API_ACCESS_CONTROL}/count`, {filter});
        return response;
    } catch (error) {
        console.error('Error while fetching the group data:', error);
        throw error;
    }
};


/**
 * Get group count data
 * @returns {Promise<Object>} Promise resolving to waiting task
 */
export const getGroupCount = async (filter ={}) => {
    try {
        const response = await post(`${API_GROUPS}/count`, {filter});
        return response;
    } catch (error) {
        console.error('Error while fetching the group count data:', error);
        throw error;
    }
};




/**
 * Create a access control
 * @returns {Promise<Object>} Promise resolving to waiting task
 */
export const createAccessControl = async (payload = []) => {
    try {
        const response = await post(`${API_ACCESS_CONTROL}/sync-group-access`, payload);
        return response;
    } catch (error) {
        console.error('Error while fetching the group data:', error);
        throw error;
    }
};


/**
 * Get access control data
 * @returns {Promise<Object>} Promise resolving to waiting task
 */
export const getAccessControlData = async (filter ={}, query ={}) => {
    try {
        const {skip = 0, limit = 10} = query;
        const response = await post(`${API_ACCESS_CONTROL}/fetch`, {filter, skip, limit});
        return response;
    } catch (error) {
        console.error('Error while fetching the group data:', error);
        throw error;
    }
};

/**
 * Get resource data
 * @returns {Promise<Object>} Promise resolving to waiting task
 */
export const getDependencyTree = async (componentType, componentCode) => {
    try {
        const payload = {
            component_type: componentType,
            component_code: componentCode
        }
        const response = await post(`${API_DEPENDENCY_VIEW}`, payload);
        return response;
    } catch (error) {
        console.error('Error getting the dependency view:', error);
        throw error;
    }
};


/**
 * Get resource data
 * @returns {Promise<Object>} Promise resolving to waiting task
 */
export const getResourcesData = async (tableName, filter = {}, sort = {}, query = {}) => {
    try {
        const { skip = 0, limit = 10 } = query;
        const payload = {
            filter,
            sort,
            skip,
            limit,
            // "fields": ['name', 'code']
        }
        const response = await post(`${API_CONFIG}${tableName}/config/fetch`, payload);
        return response;
    } catch (error) {
        console.error('Error while fetching the group data:', error);
        throw error;
    }
};


/**
 * Get resource data
 * @returns {Promise<Object>} Promise resolving to waiting task
 */
export const removePermissonById = async (id) => {
    try {
        const response = await del(`${API_PERMISSION_DELETE}/${id}`);
        return response;
    } catch (error) {
        console.error('Error while fetching the group data:', error);
        throw error;
    }
};

/**
 * Get resource data
 * @returns {Promise<Object>} Promise resolving to waiting task
 */
export const getGroupsDetailsByName = async (name) => {
    try {
        const response = await get(`${API_GROUPS}/get_by_name/${name}`);
        return response;
    } catch (error) {
        console.error('Error while fetching the group data:', error);
        throw error;
    }
};




